module.exports = __webpack_public_path__ + "img/51.486d8602.png";